/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from "react";

const SearchData = ({ data, setQueryData, onClickLink }) => {
  console.log("data", data);
  const dropdownRef = useRef(null);
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setQueryData([]); // close when clicked outside
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const openVideo = (videoId) => {
    window.open(`https://www.youtube.com/watch?v=${videoId}`, "_blank");
    onClickLink();
  };

  return (
    <ul
      ref={dropdownRef}
      className="absolute text-left bottom-full h-[300px] z-50 bg-white border-solid border rounded-lg shadow-md p-1 list-none overflow-auto"
    >
      {data.map((video) => {
        return (
          <li
            onClick={() => openVideo(video.videoId)}
            className="flex justify-start items-center gap-2 py-2 px-4 rounded-lg cursor-pointer hover:bg-[var(--input-focus-bg)]"
          >
            <img
              className="w-20 h-auto"
              src={video.thumbnail}
              alt="video.title"
            ></img>
            <p>{video.title}</p>
          </li>
        );
      })}
    </ul>
  );
};

export default SearchData;
